











import {Component, Vue} from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const auth = namespace('auth')
const event = namespace('event')


@Component({
  components: {
  }
})
export default class Logout extends Vue {
  @auth.Action('logout') protected authLogout: any
  @event.Mutation('clear') protected clear: any

  mounted() {
    this.authLogout()
      .then(() => {
        this.$router.push({name: 'Auth'}).catch(()=>{})
        this.clear()
      })
      .catch(() => {
      })
  }


}
